var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clientTop" }, [
    _c("div", { staticClass: "clientTopLeft" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "clientTopLeftB" },
        [
          _vm._m(1),
          _vm._l(2, function (item, index) {
            return _c("div", { key: index, staticClass: "center" }, [
              _c(
                "div",
                {
                  staticClass: "card",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("ActivityDetail")
                    },
                  },
                },
                [_vm._m(2, true), _vm._m(3, true)]
              ),
            ])
          }),
          _vm._m(4),
        ],
        2
      ),
    ]),
    _vm._m(5),
    _c("div", { staticClass: "clientTopRight" }, [
      _c(
        "div",
        { staticClass: "clientTopRightT", on: { click: _vm.shareCustomer } },
        [_vm._v(" 快快分享给你的客户 ")]
      ),
      _c("div", { staticClass: "clientTopRightB" }, [
        _vm._m(6),
        _c("div", { staticClass: "clientTopRightBR" }, [
          _c(
            "div",
            {
              staticClass: "imgBox",
              staticStyle: { "margin-right": "0.22rem" },
            },
            [
              _c("qr", { attrs: { size: 100, text: _vm.text } }),
              _c("p", [_vm._v("1 微信扫描二维码")]),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "clientTopLeftT" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("点击下方新建客户互动营销")]),
      _c("p", { staticClass: "p2" }, [_vm._v("查看全部客户营销活动")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "left" }, [
      _c("i", {
        staticClass: "el-icon-arrow-left",
        staticStyle: { "font-size": "0.36rem", cursor: "pointer" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cardL" }, [
      _c("div", { staticClass: "cardTitle" }),
      _c("div", { staticClass: "cardText" }, [
        _vm._v(" 礼"),
        _c("span", [_vm._v("包")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cardR" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("旅游基金限时领")]),
      _c("p", { staticClass: "p2" }, [_vm._v("优惠券礼包")]),
      _c("p", { staticClass: "p3" }, [_vm._v("用户一次获得多张优惠券")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right" }, [
      _c("i", {
        staticClass: "el-icon-arrow-right",
        staticStyle: { "font-size": "0.36rem", cursor: "pointer" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { padding: "0.2rem 0" } }, [
      _c("div", { staticClass: "line" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "clientTopRightBL" }, [
      _c("i", {
        staticClass: "el-icon-caret-top",
        staticStyle: { "font-size": "0.2rem", cursor: "pointer" },
      }),
      _c("div", { staticClass: "clientTopRightBLLineBox" }, [
        _vm._v(" 活动时间：2021.09.30-12.03 同业专享 "),
      ]),
      _c("i", {
        staticClass: "el-icon-caret-bottom",
        staticStyle: { "font-size": "0.2rem", cursor: "pointer" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }